import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonPurchaseList from "../../../components/Common/CommonPurchaseList";
import {
    BreadcrumbShowCountlabel,
    commonPageFieldList,
    commonPageFieldListSuccess,
} from "../../../store/actions";
import { url, mode, pageId } from "../../../routes/index";
import { PageLoadingSpinner } from "../../../components/Common/CommonButton";
import ERPUrl from "./index";
import { loginCompanyID, loginPartyID } from "../../../components/Common/CommonFunction";
import {
    deleteERPUrlSuccess,
    delete_ERPUrl_ID,
    editERPUrlID,
    getERPUrl_API,
    saveERPUrlMaster_Success,
    updateERPUrlIDSuccess
} from "../../../store/Utilites/ERPUrlRedux/action";

const ERPUrlList = () => {

    const dispatch = useDispatch();

    const [updateData, setUpdateData] = useState([]);
    const reducers = useSelector(
        (state) => ({
            listBtnLoading: state.ERPUrlReducer.listBtnLoading,
            tableList: state.ERPUrlReducer.ERPUrlData,
            editData: state.ERPUrlReducer.editData,
            updateMsg: state.ERPUrlReducer.updateMsg,
            deleteMsg: state.ERPUrlReducer.deleteMsg,
            postMsg: state.ERPUrlReducer.postMsg,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageFieldList
        })
    );

    const action = {
        getList: () => getERPUrl_API(loginPartyID(), loginCompanyID()),
        editId: editERPUrlID,
        deleteId: delete_ERPUrl_ID,
        postSucc: saveERPUrlMaster_Success,
        updateSucc: updateERPUrlIDSuccess,
        deleteSucc: deleteERPUrlSuccess
    };

    const goButtonHandler = () => {
        dispatch(
            getERPUrl_API(
                loginPartyID(),
                loginCompanyID()
            )
        );
    };

    useEffect(() => {
        const page_Id = pageId.ERP_URL_L
        dispatch(commonPageFieldListSuccess(null))
        dispatch(commonPageFieldList(page_Id))
        goButtonHandler(); // CommonPurchaseList doesn't auto-fetch on mount — trigger it here

        return () => {
            dispatch(commonPageFieldListSuccess(null))
        }
    }, []);



    const { pageField, listBtnLoading, tableList } = reducers

    useEffect(() => {
        // If reducer stores the full response ({StatusCode, Status, Data:[...]})
        // If reducer stores only the Data array, use tableList directly
        const urls = Array.isArray(tableList)
            ? tableList
            : Array.isArray(tableList?.Data)
                ? tableList.Data
                : [];

        setUpdateData(urls);
        dispatch(BreadcrumbShowCountlabel(`Count:${urls.length}`));
    }, [tableList]);





    const listReducers = { ...reducers, tableList: updateData };

    return (
        <React.Fragment>
            <PageLoadingSpinner isLoading={(listBtnLoading || !pageField)} />
            {
                (pageField) &&
                <CommonPurchaseList
                    action={action}
                    reducers={listReducers}
                    masterPath={url.ERP_URL_M}
                    newBtnPath={url.ERP_URL_M}
                    pageMode={mode.defaultList}
                    goButnFunc={goButtonHandler}
                    MasterModal={ERPUrl}
                    ButtonMsgLable={"ERP Urls"}
                    deleteName={"id"}
                />

            }
        </React.Fragment>
    )
}

export default ERPUrlList;